<template>
  <div class="aside-toolbar" :style="{ top: offset + 'px', left: position ? position.right + 14 + 'px' : null }">
    <div class="avatar-box" v-if="showOptions.avatar">
      <el-popover v-model="visibleDetailAuthor" placement="right" trigger="hover" :visible-arrow="false" :offset="52">
        <DetailAuthor :detail="detail" @refresh="refresh"/>
        <img slot="reference" class="avatar" :src="detail.user.avatar || ''" @click="handleClickAvatar"/>
      </el-popover>
    </div>
    <div class="item" @click="onLike" v-if="showOptions.like">
      <img
        class="icon"
        :src="
          `${
            detail.is_like
              ? require('@/assets/images/aside_dianzanle.png')
              : require('@/assets/images/aside_dianzan.png')
          }`
        "
      />
      <span class="txt">{{ formatCount(detail.like_count) }}</span>
    </div>
    <div class="item" @click="onFavorite" v-if="showOptions.favorite">
      <img
        class="icon"
        :src="
          `${
            detail.is_favorite
              ? require('@/assets/images/aside_shoucangle.png')
              : require('@/assets/images/aside_shoucang.png')
          }`
        "
      />
      <span class="txt">{{ formatCount(detail.favorite_count) }}</span>
    </div>
    <div class="item" @click="onComment" v-if="showOptions.comment">
      <img class="icon" :src="`${require('@/assets/images/aside_pinglun.png')}`"/>
      <span class="txt">{{ formatCount(detail.comment_count) }}</span>
    </div>
    <div class="item" @click="shareImage" v-if="showOptions.shareImage">
      <img class="icon" :src="`${require('@/assets/images/aside_fenxiang.png')}`"/>
      <span class="txt">分享</span>
    </div>
    <div class="item" @click="shareText" v-if="showOptions.shareText">
      <img class="icon" :src="`${require('@/assets/images/aside_fenxiang.png')}`"/>
      <span class="txt">分享</span>
    </div>
    <div class="item" @click="goEdit" v-if="showOptions.goEdit">
      <img class="icon" :src="`${require('@/assets/zs_imgs/post_edit_icon.png')}`"/>
      <span class="txt">发帖</span>
    </div>
    <div class="aside-box" v-if="showAside">
      <div v-if="isCommentTop" class="wrapper-1">
        <DetailAuthor :detail="detail" style="width: 100%;" @refresh="refresh"/>
      </div>
      <div class="wrapper-2" :style="{ height: isCommentTop ? 'calc(100vh - 240px)' : 'calc(100vh - 73px)' }">
        <detail-tool v-if="isCommentTop" :detail="detail"/>
        <detail-comment
          :detail="detail"
          :list="commentList"
          :pagination="commentPagination"
          @refresh="refresh"
          @getCommentList="getCommentList"
          @scrollToTop="onScrollToTop"
          @scrollArrowBottom="onScrollArrowBottom"
        />
      </div>
      <!-- 收起 -->
      <div class="close-aside" @click="onComment">
        <img src="@/assets/images/expand-close-icon.svg" alt=""/>
      </div>
      <!-- 滚动到顶部 -->
      <detail-scroll-top style="position: absolute; bottom: 6px;right: -40px;margin-left: 0;left: auto"/>
    </div>

    <!-- 分享弹窗 -->
    <!-- <share-view ref="shareView"/> -->
  </div>
</template>

<script>
import Clipboard from "clipboard"
import { apiContentLike } from "@/api/contentApi"
import { apiUserAddFavorite } from "@/api/userApi"
// components
import DetailComment from "./detailComment.vue"
import DetailAuthor from "./detailAuthor"
import DetailTool from "./detailTool.vue"
import DetailScrollTop from "./detailScrollTop.vue"
import { mapGetters } from "vuex"
import { debounce } from "@/plugins/util"

export default {
  name: "AsideToolbar",
  components: { DetailAuthor, DetailComment, DetailTool, DetailScrollTop },
  props: {
    detail: {
      type: Object,
      default: () => ({})
    },
    commentList: {
      type: Array,
      default: () => []
    },
    commentPagination: {
      type: Object,
      default: () => ({})
    },
    position: {
      type: Object,
      default: null
    },
    type: {
      type: Number,
      require: false,
      default: 1
    },
    showOptions: {
      type: Object,
      require: false,
      default: () => ({
        avatar: true,
        like: true,
        favorite: true,
        comment: true,
        shareImage: true,
        shareText: false,
        goEdit: false
      })
    }
  },
  computed: {
    ...mapGetters(['loginUser'])
  },
  data() {
    return {
      visibleDetailAuthor: false,
      showAside: false,
      offset: 76,
      isCommentTop: true
    };
  },
  mounted() {
    window.addEventListener("scroll", this.onScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.onScroll);
  },
  methods: {
    refresh(detail, user) {
      this.$emit("refresh", detail, user);
    },
    onScroll() {
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
      const windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
      if (scrollTop > 0 && scrollTop >= scrollHeight - windowHeight - 144) {
        this.offset = scrollHeight - (scrollTop + windowHeight) - 76;
      } else {
        this.offset = 76;
      }
      // this.scrollTop = scrollTop + 6;
    },
    // 点赞
    onLike: debounce(function () {
      // if (!this.isLogin()) {
      //   return false;
      // }
      let params = {
        is_like: this.detail.is_like ? 0 : 1,
        origin_id: this.detail.id,
        type: this.type
      }
      apiContentLike(params).then(res => {
        this.detail.is_like = params.is_like
        params.is_like ? this.detail.like_count++ : this.detail.like_count--
        if (this.detail.like_count < 0) this.detail.like_count = 0
        this.$emit("refresh", this.detail)
      })
    }, 100),
    // 打赏用户
    onReward() {
      this.$message({
        type: "info",
        message: "功能暂未开放"
      })
    },
    // 收藏文章
    onFavorite() {
      if (!this.isLoginShow()) return false
      let params = {
        origin_id: this.detail.id,
        type: this.type
      }
      apiUserAddFavorite(params).then(res => {
        if (res.code == 0) {
          this.detail.is_favorite = this.detail.is_favorite ? 0 : 1
          this.detail.is_favorite ? this.detail.favorite_count++ : this.detail.favorite_count--
          this.$emit("refresh", this.detail)
        }
      })
    },
    shareImage(detail) {
      this.$emit("share")
    },

    goEdit() {
      if (!this.isLoginShow("")) {
        sessionStorage.setItem("login_jump_path", `/${this.alias}/editor`)
        return false
      }

      if (!this.isAuthRealName()) {
        sessionStorage.setItem("login_jump_path", `/${this.alias}/editor`)
        return false
      }
      this.$router.push(`/${this.alias}/editor`);
    },
    shareText() {
      let shareText = `${this.loginUser.username}分享了文章\r\n`
      shareText += window.location.href + "\r\n";
      shareText += "来自GameKee";

      let $div = document.createElement("div");
      $div.setAttribute("data-clipboard-text", shareText);
      $div.classList.add("page-share-copy-btn");
      document.body.appendChild($div);
      let clipboard = new Clipboard(".page-share-copy-btn");
      clipboard.on("success", e => {
        this.$message("复制成功！");
        document.body.removeChild($div);
        clipboard.destroy();
      });
      clipboard.on("error", e => {
        // 不支持复制
        this.$message("浏览器不支持自动复制,请更换其他浏览器");
        document.body.removeChild($div);
        clipboard.destroy();
      });
      $div.click();
    },
    onComment() {
      // this.showAside = !this.showAside;
      // this.$emit("showAside", this.showAside);
      this.$emit("comment");
    },
    onScrollToTop() {
      this.isCommentTop = true;
    },
    onScrollArrowBottom() {
      this.isCommentTop = false;
    },
    handleClickAvatar() {
      this.$router.push(`/user/index/${this.detail.user.uid}.html`);
    },
    formatCount(count) {
      if (count > 100000000) {
        const num = count / 100000000;
        if (num == (count / 100000000).toFixed(1)) {
          return num + "亿";
        } else {
          return (count / 100000000).toFixed(1) + "亿+";
        }
      } else if (count >= 10000) {
        const num = count / 10000;
        if (num == (count / 10000).toFixed(1)) {
          return num + "W";
        } else {
          return (count / 10000).toFixed(1) + "W+";
        }
      } else if (count >= 1000) {
        const num = count / 1000;
        if (num == (count / 1000).toFixed(1)) {
          return num + "K";
        } else {
          return (count / 1000).toFixed(1) + "K+";
        }
      } else {
        return count;
      }
    },
    // 获取评论列表
    getCommentList(type) {
      this.$emit("getCommentList", type);
    }
  }
};
</script>

<style lang="less" scoped>
.aside-toolbar {
  position: fixed;
  right: -100px;
  top: 76px;
  z-index: 10;
  width: 58px;
  width: fit-content;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  .avatar-box {
    width: 58px;
    height: 58px;
    border-radius: 30px;
    box-sizing: border-box;
    padding: 4px;
    border: 1px solid #d1d1d1;
    overflow: hidden;
    background-color: #fff;
    .avatar {
      display: block;
      width: 100%;
      height: 100%;
      border-radius: 30px;
    }
  }
  .item {
    width: 58px;
    height: 58px;
    border-radius: 30px;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 2px;
    font-weight: 400;
    font-size: 12px;
    color: #999999;
    line-height: 14px;
    cursor: pointer;
    .icon {
      font-size: 0;
      width: 28px;
      height: 28px;
    }
    .txt {
      color: #424242;
      font-size: 11px;
    }
  }
}

@keyframes bounce {
  0%,
  6%,
  15%,
  27% {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    transform: translateZ(0);
  }

  12%,
  13% {
    animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
    transform: translate3d(0, -30px, 0) scaleY(1.1);
  }
  19% {
    animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
    transform: translate3d(0, -15px, 0) scaleY(1.05);
  }
  22% {
    transform: translateZ(0) scaleY(0.95);
    transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  25% {
    transform: translate3d(0, -4px, 0) scaleY(1.02);
  }
}

.aside-box {
  position: absolute;
  left: -6px;
  top: -14px;
  background: rgba(174, 181, 203, 0.45);
  border-radius: 8px;
  padding: 6px;
  z-index: 10;
  .wrapper-1 {
    position: relative;
    z-index: 10;
    width: 348px;
    margin-bottom: 8px;
    border-radius: 8px;
    background: #ffffff;
  }
  .wrapper-2 {
    position: relative;
    z-index: 10;
    width: 348px;
    background: #ffffff;
    border-radius: 8px;
  }
  .close-aside {
    position: absolute;
    z-index: 9;
    top: 50%;
    right: -17px;
    width: 33px;
    height: 70px;
    background: #eaeef3;
    border-radius: 5px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 10px;
      height: 14px;
      margin-left: 10px;
    }
  }
}
</style>
